import Model from './model.js'

export default {
  Read: function (params) {
    Model.Read(params)
  },
  Register: function (params) {
    Model.Register(params)
  },
  Update: function (params) {
    Model.Update(params)
  },
  Detail: function (params) {
    Model.Detail(params)
  },
  UserList: function (params) {
    if(params.action === "Next") {
      params.data.url = params.self.state.NextPage;
    }
    Model.UserList(params)
  }
}


// WEBPACK FOOTER //
// ./src/App/tenant/tenant/presenter.js